import { useQuery } from '@tanstack/react-query';
import { fetchBehaviorData } from '../api/students';

const useAllStudentBehaviorData = (uid, typeOfUser) => {
  return useQuery({
    queryKey: ['fetchBehaviorData', uid, typeOfUser],
    queryFn: async () => {
      if (!uid || !typeOfUser) {
        return null;
      }

      try {
        const fetchedData = await fetchBehaviorData(uid, typeOfUser);
        
        // Ensure we return an array, not an object or null
        if (Array.isArray(fetchedData)) {
          return fetchedData;
        } else if (fetchedData && typeof fetchedData === 'object') {
          // If it's an object with studentData property, extract it
          if (fetchedData.studentData && Array.isArray(fetchedData.studentData)) {
            return fetchedData.studentData;
          }
          // If it's a single object, wrap it in an array
          return [fetchedData];
        }
        
        // Return empty array instead of null
        return [];
      } catch (error) {
        console.error('Error fetching behavior data:', error);
        return [];
      }
    },
    staleTime: 60000, // Data is fresh for 1 minute
    // cacheTime: 300000, // 5 min cache
    refetchInterval: false, // Disable automatic refetching
    refetchIntervalInBackground: false, // Don't refetch in background
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnMount: false, // Don't refetch on mount if data exists
    refetchOnReconnect: false, // Don't refetch on reconnect
    enabled: !!uid && !!typeOfUser, // Only run query when uid and typeOfUser are provided
    retry: 1, // Only retry once on failure
    retryDelay: 1000, // Wait 1 second before retry
  });
};

export default useAllStudentBehaviorData;
